import { Controller } from "@hotwired/stimulus"

// Navbar that changes appearance on scroll
// Usage: data-controller="navbar-scroll"
export default class extends Controller {
  static classes = ["scrolled"]
  static values = {
    threshold: { type: Number, default: 50 }
  }

  connect() {
    this.handleScroll = this.handleScroll.bind(this)
    window.addEventListener("scroll", this.handleScroll, { passive: true })
    this.handleScroll() // Check initial state
  }

  disconnect() {
    window.removeEventListener("scroll", this.handleScroll)
  }

  handleScroll() {
    if (window.scrollY > this.thresholdValue) {
      this.element.classList.add("navbar-scrolled")
    } else {
      this.element.classList.remove("navbar-scrolled")
    }
  }
}
